// SideNavbar.js - Fixed version with proper permission filtering
import { Image, NavItem } from "react-bootstrap";
import { NavLink } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useState, useEffect, useCallback, useMemo } from "react";
import storage from "../../apis/Storage";
import logo from "../../assets/Images/Vizlink_logo.png";

// ============================================================================
// Configuration - Single source of truth with per-role route visibility
// ============================================================================

const MENU_CONFIG = {
  distributor: {
    label: "Distributor",
    icon: "fas fa-users",
    parent: "Distributor",
    routes: [
      {
        path: "/AddDistributorInductionForm",
        label: "Distributor Induction form",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/Distributors",
        label: "Complete Distributors List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/IncompleteDistributors",
        label: "Incomplete Distributors",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  qrTill: {
    label: "QR/Till Details",
    icon: "fas fa-qrcode",
    parent: "QR/Till Details",
    routes: [
      {
        path: "/QrTillList",
        label: "QR/Till List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DeliverymanUserRegistration",
        label: "User Registration",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DailyCollectionsReport",
        label: "Daily Collections Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/TillNumberDetails",
        label: "VL Till Number Details",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  vizLinkShops: {
    label: "VizLink Shops",
    icon: "fas fa-store",
    parent: "Vizlink Shops",
    routes: [
      {
        path: "/vizLinkJobsList",
        label: "Shops Induction Jobs List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: true,
        },
      },
      {
        path: "/vizLinkShopsOnBoardingDetails",
        label: "Shops On-Boarding Details",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: true,
        },
      },
      {
        path: "/vizLinkShopsList",
        label: "VizLink Shops List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: true,
        },
      },
      {
        path: "/VizShopsRequestListing",
        label: "Manage Shops List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/sectors",
        label: "Sectors List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/SectorBasedReport",
        label: "Sector-Based Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  vizLinkAgents: {
    label: "VizLink Agents",
    icon: "fas fa-user-tie",
    parent: "Vizlink Agents",
    routes: [
      {
        path: "/VizAgentsList",
        label: "Manage Agents",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/RegisteredAgentsList",
        label: "Registered Agents",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  dailyOrders: {
    label: "Daily Orders",
    icon: "fas fa-clipboard-list",
    parent: "Daily Orders",
    routes: [
      {
        path: "/NewOrdersForm",
        label: "New Orders Form",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/PaymentStatusReport",
        label: "Shop-wise Payment Status Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DLMCollectionReport",
        label: "Deliveryman-wise Collection Details Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DLMWiseBankDepositReport",
        label: "Deliveryman-wise Bank Deposit Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/BankWiseDepositReport",
        label: "Bank-wise Deposit Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/InvoiceAllocationListing",
        label: "Invoice Allocation Listing",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/TransactionReopeningListing",
        label: "Transaction Re-Opening",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/SCRDetailReport",
        label: "SCR Detail Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/SCRReport",
        label: "SCR Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  deliverymanReports: {
    label: "Deliveryman Reports",
    icon: "fas fa-truck",
    parent: "Deliveryman Reports",
    routes: [
      {
        path: "/DeliverymanUniqueShopsReport",
        label: "Deliveryman Unique Shops Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DlmUniqueShopsDetailReport",
        label: "DLM Unique Shops Detail Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  lendingReports: {
    label: "Lending Reports",
    icon: "fas fa-hand-holding-usd",
    parent: "Lending Reports",
    routes: [
      {
        path: "/LoanKycReport",
        label: "Loan Kyc Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/FinjaLoanReport",
        label: "Successful Loan Details Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/LoanDisbursementReport",
        label: "Loan Disbursement Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/LoanRepaymentReport",
        label: "Loan Repayment Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DisbursementRejectionReport",
        label: "Disbursement Rejection Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/FinancingLedgerReport",
        label: "Financing Ledger Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  vlLoyaltyProgram: {
    label: "VL Loyalty Program",
    icon: "fas fa-star",
    parent: "VL Loyalty Program",
    routes: [
      {
        path: "/SchemesList",
        label: "Schemes List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/CoinsHistoryReport",
        label: "Coins History Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DistributorCoinsDisbursmentReport",
        label: "Distributor Coins Disbursement Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DeliveryManCoinsPaymentReport",
        label: "Deliveryman Coins Payment Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DistributorCoinsPaymentReport",
        label: "Distributor Coins Payment Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/LoanVlpLedger",
        label: "Coin Repayment Scheme",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/GenerateCoinListing",
        label: "Generate Coin Listing",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  m2dReports: {
    label: "M2D Reports",
    icon: "fas fa-file-invoice",
    parent: "M2D Reports",
    routes: [
      {
        path: "/InvoiceWiseDailyCollectionDetails",
        label: "Invoice-wise Daily Collection Details",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/InvoiceWisePaymentBreakup",
        label: "Invoice-wise Payment Break-up",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/monthWiseM2DReport",
        label: "Month-Wise M2D Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/1BillPaymentReport",
        label: "1Bill Payment Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  financing: {
    label: "Financing",
    icon: "fas fa-coins",
    parent: "Financing",
    routes: [
      {
        path: "/KYCListingForm",
        label: "KYC Listing Form",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DisbursementFormList",
        label: "Disbursement Form List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/CBDataSharingForm",
        label: "CB Data Sharing",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  whitelisting: {
    label: "Whitelisting",
    icon: "fas fa-check-circle",
    parent: "Whitelisting",
    routes: [
      {
        path: "/ShopKeeperInformationList",
        label: "ShopKeeper Information",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/ShopTransactionalData",
        label: "Shop Transactional Data",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  onboardingRequest: {
    label: "Onboarding Request",
    icon: "fas fa-user-plus",
    parent: "Onboarding Request",
    routes: [
      {
        path: "/MblDistributorOnboardingList",
        label: "Mbl Distributor Onboarding",
        roles: {
          Administrator: false,
          CoreAppUser: false,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  vfoModule: {
    label: "VFO Module",
    icon: "fas fa-people-arrows",
    parent: "VFO Module",
    routes: [
      {
        path: "/VFOVisitList",
        label: "VFO Visit List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: true,
        },
      },
      {
        path: "/VFODailyVistSummaries",
        label: "VFO Daily Visit Summaries",
        roles: {
          Administrator: false,
          CoreAppUser: false,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/VfoTrackReport",
        label: "VFO Track Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: true,
        },
      },
      {
        path: "/VfoPerformanceReport",
        label: "VFO Performance Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  settings: {
    label: "Settings",
    icon: "fas fa-cog",
    parent: "Settings",
    routes: [
      {
        path: "/ManageUsers",
        label: "Manage Users",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/UserDataCorrection",
        label: "User Data Correction",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/UserBlockList",
        label: "User Block List",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/CityAndArea",
        label: "Manage City / Area",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/MfiWalletRequiredLimit",
        label: "Manage Mfi Wallet Limit",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/BusinessEntityType",
        label: "Manage Business Entity Types",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/Banks",
        label: "Manage Banks",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/Permissions",
        label: "Manage Permissions",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/Versions",
        label: "Manage Versions",
        roles: {
          Administrator: true,
          CoreAppUser: false,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/UserActivity",
        label: "User Activity",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/Notifications",
        label: "Notifications",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/NotificationsScheduler",
        label: "Auto Notifications",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/AppGlobalSetting",
        label: "App Global Setting",
        roles: {
          Administrator: true,
          CoreAppUser: false,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
    ],
  },
  vlConnect: {
    label: "VL Connect",
    icon: "fas fa-envelope",
    parent: "VL Connect",
    routes: [
      {
        path: "/VLCCommunicationListing",
        label: "Communication Listing",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DistributorInbox",
        label: "Distributor Inbox",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  vlConnectReports: {
    label: "VL Connect Reports",
    icon: "fas fa-chart-line",
    parent: "VL Connect Reports",
    routes: [
      {
        path: "/VLConnectDetailReport",
        label: "VL Connect Detail Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/VLConnectActivityReport",
        label: "VL Connect Activity Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/VLConnectSummaryReport",
        label: "VL Connect Summary Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
  reports: {
    label: "Reports",
    icon: "fas fa-chart-bar",
    parent: "Reports",
    routes: [
      {
        path: "/ExportReport",
        label: "Export Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: false,
          RsoAdmin: false,
        },
      },
      {
        path: "/DailyTransactionsSummary",
        label: "Digital Transaction Summary",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/UserDetailsReport",
        label: "User Details Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/ShopwiseTransactionsDetails",
        label: "Shop-wise Transactions Details",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DigitalCollectionsReport",
        label: "Digital Collections Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/RsoDetailsReport",
        label: "Rso Details Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: true,
        },
      },
      {
        path: "/RsoPerformanceReport",
        label: "Rso Performance Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: true,
        },
      },
      {
        path: "/ShopWisePulseReport",
        label: "Shops-Wise Pulse Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/DateWiseShopsSummaryReport",
        label: "Active Shops Summary",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
      {
        path: "/ShopsDetailReport",
        label: "Shops Detail Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: true,
        },
      },
      {
        path: "/DisputedTransactionsReport",
        label: "Disputed Transactions Report",
        roles: {
          Administrator: true,
          CoreAppUser: true,
          DistributorUser: true,
          RsoAdmin: false,
        },
      },
    ],
  },
};

// Top-level standalone menu items
const STANDALONE_MENUS = {
  dashboard: {
    path: "/dashboard",
    label: "Dashboard",
    roles: {
      Administrator: true,
      CoreAppUser: true,
      DistributorUser: true,
      RsoAdmin: true,
    },
  },
  advertisements: {
    path: "/Advertisements",
    label: "Advertisements",
    roles: {
      Administrator: true,
      CoreAppUser: true,
      DistributorUser: false,
      RsoAdmin: false,
    },
  },
};

// ============================================================================
// Helper Functions
// ============================================================================

const isRouteVisibleForRole = (route, role) => {
  if (!route || !route.roles) return false;
  return route.roles[role] === true;
};

// Build path-to-menu lookup for O(1) access
const PATH_TO_MENU = Object.entries(MENU_CONFIG).reduce((acc, [key, menu]) => {
  menu.routes.forEach((route) => {
    acc[route.path] = key;
  });
  return acc;
}, {});

const getMenuKeyForPath = (path) => PATH_TO_MENU[path] || null;

// ============================================================================
// Helper Hooks
// ============================================================================

const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handler = () =>
      setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return size;
};

const useAdminLTETreeview = () => {
  useEffect(() => {
    if (
      window.$ &&
      typeof window.$('[data-widget="treeview"]').Treeview === "function"
    ) {
      window.$('[data-widget="treeview"]').Treeview("init");
    }
  }, []);
};

// ============================================================================
// Navigation Components
// ============================================================================

// Update NavLinkItem to accept onClick
const NavLinkItem = ({ to, label, isActive, onClick }) => (
  <NavItem>
    <NavLink
      href={void 0}
      tag={Link}
      to={to}
      className={isActive ? "active" : ""}
      onClick={onClick}
    >
      <p>{label}</p>
    </NavLink>
  </NavItem>
);

// Update MenuSection with proper click handling
const MenuSection = ({
  menuKey,
  menu,
  openMenus,
  toggleMenu,
  isActive,
  renderRoute,
}) => {
  const isOpen = openMenus.includes(menuKey);

  return (
    <NavItem className={isOpen ? "menu-open" : ""}>
      <NavLink
        href={void 0}
        onClick={(e) => {
          e.preventDefault();
          toggleMenu(menuKey);
        }}
        className={isActive ? "active" : ""}
      >
        <p>
          {menu.label}
          <i className="right fas fa-angle-left"></i>
        </p>
      </NavLink>
      <ul className="nav nav-treeview">
        {menu.routes.map((route) => renderRoute(route))}
      </ul>
    </NavItem>
  );
};

// ============================================================================
// Main Sidebar Component
// ============================================================================

const Sidebar = ({
  userRole,
  userRights,
  permittedPages,
  isNavbarOpen,
  onClickOutside,
}) => {
  const location = useLocation();
  const currentPath = location.pathname.split("/")[1] || "";
  const windowSize = useWindowSize();
  useAdminLTETreeview();

  const [openMenus, setOpenMenus] = useState([]);
  // Set initial menu based on current path
  useEffect(() => {
    const menuKey = getMenuKeyForPath(currentPath);
    if (menuKey) {
      setOpenMenus([menuKey]);
    }
  }, [currentPath]);

  const toggleMenu = useCallback((key) => {
    setOpenMenus((prev) => {
      // If menu is already open, remove it (collapse)
      if (prev.includes(key)) {
        return prev.filter((item) => item !== key);
      }
      // Otherwise, add it to the list (keep all other menus open)
      return [...prev, key];
    });
  }, []);

  // Check if a page exists in permissions
  const hasPagePermission = useCallback(
    (pageUrl) => {
      // Administrator always has access
      if (userRole === "Administrator" || userRole === "RsoAdmin") return true;

      // If no permissions data, deny access
      if (
        !permittedPages ||
        !Array.isArray(permittedPages) ||
        permittedPages.length === 0
      ) {
        return false;
      }

      // Check if the pageUrl exists in permittedPages with at least one action checked
      return permittedPages.some((page) => {
        if (typeof page === "string") return page === pageUrl;

        // Check if pageUrl matches and has at least one checked action
        return (
          page.pageUrl === pageUrl &&
          page.actions?.some((action) => action.ischecked)
        );
      });
    },
    [userRole, permittedPages],
  );

  // Check if a parent menu has any permitted pages
  const hasParentPermission = useCallback(
    (parentName) => {
      // Administrator always has access
      if (userRole === "Administrator" || userRole === "RsoAdmin") return true;

      // If no permissions data, deny access
      if (
        !permittedPages ||
        !Array.isArray(permittedPages) ||
        permittedPages.length === 0
      ) {
        return false;
      }

      // Check if any page with this parent is in the permitted pages
      return permittedPages.some((page) => {
        if (typeof page === "string") return false;

        return (
          page.parentName?.toLowerCase() === parentName?.toLowerCase() &&
          page.actions?.some((action) => action.ischecked)
        );
      });
    },
    [permittedPages, userRole],
  );

  // Render a single route item
  const renderRoute = useCallback(
    (route) => {
      const routePath = route.path;

      // Check role visibility first
      if (!isRouteVisibleForRole(route, userRole)) return null;

      // For non-admin roles, check if page has permission
      if (userRole !== "Administrator") {
        if (!hasPagePermission(routePath)) return null;
      }

      const isActive = currentPath === route.path.replace("/", "");
      return (
        <NavLinkItem
          key={route.path}
          to={routePath}
          label={route.label}
          isActive={isActive}
          onClick={() => {
            // When a sub-item is clicked, add its parent menu to open list
            const menuKey = getMenuKeyForPath(routePath);
            if (menuKey) {
              setOpenMenus([menuKey]);
            }
          }}
        />
      );
    },
    [currentPath, isRouteVisibleForRole, hasPagePermission, userRole],
  );

  // Render a menu section
  // Render a menu section
  const renderMenu = useCallback(
    (menuKey) => {
      const menu = MENU_CONFIG[menuKey];
      if (!menu) return null;

      // For non-admin roles, check parent permission first
      if (userRole !== "Administrator") {
        if (!hasParentPermission(menu.parent)) return null;
      }

      // Check if menu has any visible routes
      const visibleRoutes = menu.routes.filter((route) => {
        if (!isRouteVisibleForRole(route, userRole)) return false;
        if (userRole !== "Administrator") {
          return hasPagePermission(route.path);
        }
        return true;
      });

      if (visibleRoutes.length === 0) return null;

      const isActive = visibleRoutes.some(
        (route) => route.path.replace("/", "") === currentPath,
      );

      return (
        <MenuSection
          key={menuKey}
          menuKey={menuKey}
          menu={{ ...menu, routes: visibleRoutes }}
          openMenus={openMenus}
          toggleMenu={toggleMenu}
          isActive={isActive}
          renderRoute={renderRoute}
        />
      );
    },
    [
      currentPath,
      openMenus,
      toggleMenu,
      renderRoute,
      isRouteVisibleForRole,
      hasParentPermission,
      hasPagePermission,
      userRole,
    ],
  );

  // Top-level navigation items
  const renderTopLevelItem = useCallback(
    (key) => {
      const item = STANDALONE_MENUS[key];
      if (!item) return null;

      // Check role visibility
      if (!item.roles || item.roles[userRole] !== true) return null;

      // For non-admin roles, check page permission
      if (userRole !== "Administrator") {
        if (!hasPagePermission(item.path)) return null;
      }

      const isActive = currentPath === item.path.replace("/", "");
      return (
        <NavLinkItem
          key={item.path}
          to={item.path}
          label={item.label}
          isActive={isActive}
        />
      );
    },
    [currentPath, hasPagePermission, userRole],
  );

  // Determine which menu keys to show based on role and permissions
  const visibleMenuKeys = useMemo(() => {
    return Object.keys(MENU_CONFIG).filter((key) => {
      const menu = MENU_CONFIG[key];

      // Check if menu has any visible routes for this role
      const hasVisibleRoutes = menu.routes.some((route) =>
        isRouteVisibleForRole(route, userRole),
      );
      if (!hasVisibleRoutes) return false;

      // For non-admin roles, check parent permission
      if (userRole !== "Administrator") {
        return hasParentPermission(menu.parent);
      }

      return true;
    });
  }, [userRole, isRouteVisibleForRole, hasParentPermission]);

  return (
    <div className={isNavbarOpen ? "sidebar-backdrop" : ""}>
      <aside className="main-sidebar sidebar-sticky sidebar-light-primary elevation-4 sidebar">
        <div className={isNavbarOpen ? "sidebar" : ""}>
          {/* Header */}
          <span className="d-flex align-items-center justify-content-between px-3">
            <a className="clearfix" href="/dashboard">
              <Image src={logo} alt="Logo" className="brand-image" />
            </a>
            {windowSize.width < 993 && (
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClickOutside}
              />
            )}
          </span>

          {/* Navigation */}
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
              {renderTopLevelItem("dashboard")}
              {visibleMenuKeys.map(renderMenu)}
              {renderTopLevelItem("advertisements")}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

// ============================================================================
// Role-based wrapper
// ============================================================================

const RoleBasedSideNavbar = (props) => {
  return <Sidebar {...props} />;
};

// ============================================================================
// Redux connection
// ============================================================================

const mapStateToProps = () => {
  const permissions = storage.get("_userPermissionsList");
  let parsedPermissions = [];
  try {
    parsedPermissions = permissions ? JSON.parse(permissions) : [];
  } catch (e) {
    console.error("Error parsing permissions:", e);
    parsedPermissions = [];
  }

  return {
    userRole: storage.get("_appUserRole") || "RsoAdmin",
    userRights: JSON.parse(storage.get("_userRights") || "null"),
    permittedPages: parsedPermissions,
  };
};

export default connect(mapStateToProps)(RoleBasedSideNavbar);
